define('enums/bindingHandlers/rangePickerModes',[],function () {
    'use strict';

    return {
        BETWEEN: 'BETWEEN',
        OVER: 'OVER',
        UNDER: 'UNDER'
    };
});
